import React from 'react';
import t from '@unicat/i18n/Translate';
import { ReactComponent as Back } from '@assets/icons/Back.svg';
import { useStyles } from './styles';

const BackButton = () => {
  const classes = useStyles();

  const handleBackClick = (event) => {
    event.preventDefault();

    window.history.back();
  };

  return (
    <>
      <button className={classes.button} onClick={handleBackClick}>
        <Back width={24} height={24} viewBox={'0 0 24 24'} />
        {t('Back')}
      </button>
    </>
  );
};
export default BackButton;
